module.exports = __webpack_public_path__ + "img/badge_gray_she-finance.366825b8.svg";